import React from 'react';
import classnames from 'classnames';
function SvgIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.children, children = _c === void 0 ? null : _c;
    return (React.createElement("span", { role: "img", className: classnames('svg-icon anticon', className) }, children));
}
export default SvgIcon;
